import { render, staticRenderFns } from "./SidebarNavTitle.vue?vue&type=template&id=43e0e544"
import script from "./SidebarNavTitle.vue?vue&type=script&lang=js"
export * from "./SidebarNavTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports